import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { MARKETING_STRATEGIST } from "@/constants/expert-constants";

export const useOrgCommunityMarketingExpertiseFeedStore = defineSmartFeedPiniaStore(
  "org-community-marketing-expertise-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        expertise: {
          key: "expertise",
          payload: MARKETING_STRATEGIST,
        },
      },
      metadata: {
        lastId: Number.MAX_SAFE_INTEGER,
      },
    }),
    getters: {
      feedUrl() {
        return "/expert/community";
      },
    },
  },
);
